import {Injectable} from '@angular/core';

@Injectable()
export class FileSettleStateService {
  generalTabInitialized = false;
}
